// NOTICE: KAPTION-INTEGRATION
// note-cards.GROUP — back-to-back events fold into one line. An event is a card (a private note
// carrying a structured card) or one of the platform's own activity lines. A run of events with no
// message and no note a person wrote between them, on the same day, is a group. Pure: messages in
// (camelCased, as MessageList has them), rows out; no message is changed, dropped or reordered.
import { MESSAGE_TYPES } from 'dashboard/components-next/message/constants';
import { getStructuredNoteCard, noteCardTone } from './kaptionNoteCards';

/** The card a message shows as, or null (only private notes carry cards). */
export const eventCardOf = message =>
  message.private ? getStructuredNoteCard(message.contentAttributes) : null;

const isActivity = message => message.messageType === MESSAGE_TYPES.ACTIVITY;
const isEvent = message => isActivity(message) || !!eventCardOf(message);

const dayOf = createdAt => new Date(createdAt * 1000).toDateString();

/** note-cards.GROUP.3 / note-cards.GROUP.4 — what a group's line shows. */
export const summarizeEventGroup = messages => {
  const cards = messages.map(eventCardOf).filter(Boolean);
  const lastDanger = cards
    .filter(card => noteCardTone(card) === 'danger')
    .pop();
  const leadCard = lastDanger || cards[cards.length - 1] || null;
  return {
    hasCards: cards.length > 0,
    leadCard,
    badgeCards: cards.slice(0, 3),
    lastActivity: leadCard ? null : messages[messages.length - 1],
    more: messages.length - 1,
    startAt: messages[0].createdAt,
    endAt: messages[messages.length - 1].createdAt,
  };
};

/**
 * note-cards.GROUP.1 / note-cards.GROUP.2 — the rows of the timeline: a message on its own, or a group
 * of two or more back-to-back events. A group's key is its first event's id, so it keeps its state
 * when a later event joins it (note-cards.GROUP.7). `index` is the message's place in `messages`.
 */
export const groupTimelineEvents = messages => {
  const rows = [];
  let run = [];
  const flush = () => {
    if (run.length === 1) {
      rows.push({
        type: 'message',
        key: `message-${run[0].message.id}`,
        ...run[0],
      });
    } else if (run.length > 1) {
      rows.push({
        type: 'group',
        key: `group-${run[0].message.id}`,
        items: run,
        summary: summarizeEventGroup(run.map(item => item.message)),
      });
    }
    run = [];
  };

  messages.forEach((message, index) => {
    if (isEvent(message)) {
      const sameDay =
        !run.length ||
        dayOf(run[0].message.createdAt) === dayOf(message.createdAt);
      if (!sameDay) flush();
      run.push({ message, index });
      return;
    }
    flush();
    rows.push({
      type: 'message',
      key: `message-${message.id}`,
      message,
      index,
    });
  });
  flush();
  return rows;
};
